export default function VerifiedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <rect width="48" height="48" fill="#F2FFF9" />
      <path
        d="M30.2021 2.61239C26.801 -0.870798 21.199 -0.870798 17.7979 2.61239L15.9323 4.5229L13.2623 4.4911C8.39426 4.43312 4.43312 8.39426 4.4911 13.2623L4.5229 15.9323L2.61239 17.7979C-0.870798 21.199 -0.870798 26.801 2.61239 30.2021L4.5229 32.0677L4.4911 34.7377C4.43312 39.6057 8.39427 43.5669 13.2623 43.5089L15.9323 43.4771L17.7979 45.3876C21.199 48.8708 26.801 48.8708 30.2021 45.3876L32.0677 43.4771L34.7377 43.5089C39.6057 43.5669 43.5669 39.6057 43.5089 34.7377L43.4771 32.0677L45.3876 30.2021C48.8708 26.801 48.8708 21.199 45.3876 17.7979L43.4771 15.9323L43.5089 13.2623C43.5669 8.39427 39.6057 4.43312 34.7377 4.4911L32.0677 4.5229L30.2021 2.61239ZM31.0607 20.5607L22.0607 29.5607C21.7794 29.842 21.3978 30 21 30C20.6022 30 20.2206 29.842 19.9393 29.5607L15.4393 25.0607C14.8536 24.4749 14.8536 23.5251 15.4393 22.9393C16.0251 22.3536 16.9749 22.3536 17.5607 22.9393L21 26.3787L28.9393 18.4393C29.5251 17.8536 30.4749 17.8536 31.0607 18.4393C31.6464 19.0251 31.6464 19.9749 31.0607 20.5607Z"
        fill="#1DB469"
      />
    </svg>
  );
}
